<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <field-permission-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import FieldPermissionCrud from "./FieldPermissionCrud";
    export default {
        name: "FieldPermission",
        components: {FieldPermissionCrud}
    }
</script>

<style scoped>

</style>

